import { render, staticRenderFns } from "./SpouseModule.vue?vue&type=template&id=2429ba65&scoped=true&"
import script from "./SpouseModule.vue?vue&type=script&lang=js&"
export * from "./SpouseModule.vue?vue&type=script&lang=js&"
import style0 from "./SpouseModule.vue?vue&type=style&index=0&id=2429ba65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2429ba65",
  null
  
)

export default component.exports